import { useState } from "react";
import axios from "axios";
const baseUrl = process.env.REACT_APP_API_CONFIG;

export interface OtpResponse {
  otpId: string;
  message: string;
}

export default function useSendOtp() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [otpId, setOtpId] = useState("");

  const sendOtp = async (email: string) => {
    setLoading(true);
    setError("");
    setOtpId("");
    try {
      const response = await axios.post<{ data: OtpResponse }>(
        `${baseUrl}/auth/send-code`,
        { email }
      );
      setOtpId(response.data.data.otpId);
      return { otpId: response.data.data.otpId, error: null };
    } catch (err: any) {
      let apiError = "Failed to send OTP. Please try again.";
      if (err?.response?.data?.error?.message) {
        apiError = err.response.data.error.message;
      }
      setError(apiError);
      setOtpId("");
      return { otpId: null, error: apiError };
    } finally {
      setLoading(false);
    }
  };

  return { sendOtp, otpId, loading, error };
}
